module.exports = __webpack_public_path__ + "img/27.0e31d9e6.png";